import React, { useContext, useEffect } from 'react';

import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';

import typography from 'assets/theme/base/typography';
import { UserContext } from 'context/userContext';
import { OrgContext } from 'context/orgContext';

import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import { Card } from '@mui/material';

import RecentActivity from './components/RecentActivity';
import RecentOrgs from './components/RecentOrgs';
import RecentProducts from './components/RecentProducts';

function Default() {
  const { size } = typography;
  const { userId } = useContext(UserContext);
  const { orgs } = useContext(OrgContext);


  const prods = [];
  prods.push({
    name: 'Laptop Pro Bundle',
    details: '',
  },
  {
    name: 'VolleyBall',
    details: '',
  },
  );

  useEffect(() => {
    console.log('dash con user id', userId);
    console.log('dash con org id', orgs);
  }, [userId, orgs]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox p={3} display="flex">
        <ArgonBox width="70%" pr={2}>
          <Card>
            <ArgonBox p={3}>
              <ArgonTypography variant="h6" fontWeight="medium">
                Recent Activity
              </ArgonTypography>
              <RecentActivity />
            </ArgonBox>
          </Card>
        </ArgonBox>
        <ArgonBox width="30%">
          <ArgonBox mb={2}>
            <Card>
              <ArgonBox p={3}>
                <ArgonTypography variant="h6" fontWeight="medium">
                  Recent Orgs
                </ArgonTypography>
                <RecentOrgs orgs={orgs} />
              </ArgonBox>
            </Card>
          </ArgonBox>
          <Card>
            <ArgonBox p={3}>
              <ArgonTypography variant="h6" fontWeight="medium">
                Recent Products
              </ArgonTypography>
              <RecentProducts orgs={prods} />
            </ArgonBox>
          </Card>
        </ArgonBox>
      </ArgonBox>
    </DashboardLayout>
  );
}

export default Default;
